import { SystemCredentials } from "us.common/constants";
import { ISystemCredentialsInitialState } from "../Interfaces/IInitialState";

const defaultUserCredentials: SystemCredentials = {
  subscriptionKey: "",
  instrumentationKey: "",
};

export const initialState: ISystemCredentialsInitialState = {
  userCredentials: defaultUserCredentials,
};
